import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: 'be96b023-2717-4e74-a576-9f7e6c6bb9e3',
  header: 'Sex og samfunn',
  headerLogoUrl: {
    light: '/logos/sexogsamfunn_logo.png',
    dark: '/logos/sexogsamfunn_logo.png',
  },
  subheader: '',
  version: 'Beta 1.0',
  logo: 'sexogsamfunn_logo.png',
  theme: {
    isLight: true,
    bgColor: 'bg-[#115E67]',
    textColor: 'text-[#115E67]',
    bubbles: 'bg-[#64CCC9]',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/sexogsamfunn',
  quickTextActions: ['Lag teksten kortere', 'Lag teksten mer lettlest'],
  tabsInSidebar: true,
}

export default config
